import { useEffect, useState } from 'react'
import { useSearchRolesHook } from '@dhl/keycloak-user-api'
import {
  convertToBusinessUnits,
  convertToRoleCategories,
  type RoleCategory,
  type RoleName,
} from '~/modules/adminusers/model'

export const useKeyCloakRoles = () => {
  const [roles, setRoles] = useState<RoleName[]>([])
  const [roleCategories, setRoleCategories] = useState<RoleCategory[]>([])
  const [businessUnits, setBusinessUnits] = useState<string[]>([])

  const getApiRoles = useSearchRolesHook()

  useEffect(() => {
    getRoles()
  }, [])

  const getRoles = async () => {
    const roles = await getApiRoles()
    const roleNames = roles.map((role) => role.name as RoleName)
    setRoles(roleNames)
    setRoleCategories(convertToRoleCategories(roleNames, false))
    setBusinessUnits(convertToBusinessUnits(roleNames))
  }

  return { roles, roleCategories, businessUnits }
}
